import { ENDPOINTS } from '../_config';

// #RP - Task 129 - Staffing JobAlert
export const getJobAlertPageData = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_JOBALERT_SIGNUP);
    if (request.status === 204) {
      // 204 => No content in backend
      return request;
    }
    return await request.json();
  } catch (e) {
    return null;
  }
};
